import { ProjectDataResponse } from '@/ts/HococoInterfaces';

export default class ProjectsData {
    public id: number = -1;
    public name: string = '';
    public corporationId: number;
    public owner: number;
    public description: string;
    public totalBuildings: number;
    public totalProperties: number;
    public totalVacantProperties: number;
    public totalResidents: number;
    public image: any;
    public selected: boolean;
    public vacancyRate: string;

    constructor(
        id: number,
        corporationId: number = null,
        name: string = '',
        owner: number = null,
        description: string = '',
        totalBuildings: number = null,
        totalProperties: number = null,
        totalVacantProperties: number = null,
        totalResidents: number = null,
        image: any = null,
    ) {
        this.id = id;
        this.corporationId = corporationId;
        this.name = name;
        this.owner = owner;
        this.description = description;
        this.totalBuildings = totalBuildings;
        this.totalProperties = totalProperties;
        this.totalVacantProperties = totalVacantProperties;
        this.totalResidents = totalResidents;
        this.image = image;
        this.selected = false;

        this.vacancyRate = this.calculateVacancyRate();
    }

    get persisted(): boolean {
        return (this.id !== -1);
    }

    public calculateVacancyRate(): string {
        const rateValue = Math.round((this.totalVacantProperties / this.totalProperties) * 100);
        return isNaN(rateValue) ? '0%' : rateValue + '%';
    }

    public requireUpdate(projectResponse: ProjectDataResponse): boolean {
        return (
            this.totalBuildings        !== projectResponse.totalBuildings  ||
            this.totalProperties       !== projectResponse.totalProperties ||
            this.totalResidents        !== projectResponse.totalResidents  ||
            this.totalVacantProperties !== projectResponse.totalVacantProperties ||
            this.vacancyRate           !== this.calculateVacancyRate()
        );
    }

    public updateLocalProjectData(projectResponse: ProjectDataResponse): void {
        if (this.requireUpdate(projectResponse)) {
            this.totalBuildings        = projectResponse.totalBuildings;
            this.totalProperties       = projectResponse.totalProperties;
            this.totalResidents        = projectResponse.totalResidents;
            this.totalVacantProperties = projectResponse.totalVacantProperties;
            this.vacancyRate           = this.calculateVacancyRate();
        }
    }

    public dataEquals(project: ProjectsData): boolean {
        // Check if this object's values are equal to the given object's
        if (
            this.id === project.id &&
            this.name === project.name &&
            this.owner === project.owner &&
            this.description === project.description
        ) {
            return false;
        }
    }

    public requestData() {
        return {
            name: this.name,
            corporationId: this.corporationId,
            description: this.description,
        };
    }
}
